/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import SuspenseBoundary from 'DesignSystem/SuspenseBoundary/index'
let Questions = React.lazy(() => import('./Questions/index'))
let Settings = React.lazy(() => import('./Settings/index'))



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/MedicalHistory/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Questions'
  return (<React.Fragment
>
<SuspenseBoundary
  viewPath={`${viewPath}/SuspenseBoundary`}
>
{childProps => (
<React.Fragment>
<fromFlow.When is={flowValue === 'Questions'}>
<Questions
{...childProps}
  viewPath={`${viewPath}/Questions`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Settings'}>
<Settings
{...childProps}
  viewPath={`${viewPath}/Settings`}
/>
</fromFlow.When>
</React.Fragment>
)}
</SuspenseBoundary>
{children}
</React.Fragment>)
}